// Chakra imports
import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
// Custom components
import BarChart from "components/charts/BarChart";
import {
  fetchTopGlycansBarChartData,
  topGlycansBarChartOptions,
} from "variables/charts";
import { MdBarChart } from "react-icons/md";
import React, { useState, useEffect } from 'react';

export default function TopGlycansCard(props) {
  const { ...rest } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("brand.500", "white");
  const bgButton = useColorModeValue("secondaryGray.300", "whiteAlpha.100");
  const bgHover = useColorModeValue(
    { bg: "secondaryGray.400" },
    { bg: "whiteAlpha.50" }
  );
  const bgFocus = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.100" }
  );

  // Chakra Color Mode
  // const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );


  const [chartData, setChartData] = useState({});
  const [isLoading, setIsLoading] = useState(true);  // New loading state
  const [hasError, setHasError] = useState(false);   // New error state
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchDataAndUpdateState = async () => {
      try {
        setIsLoading(true);
        const newData = await fetchTopGlycansBarChartData();
        setChartData(newData);
        setCategories(newData.categories);
        setIsLoading(false);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
        setHasError(true);
        setIsLoading(false);
      }
    };
    fetchDataAndUpdateState();
  }, []);

  const options = { // Dynamically set the options
    ...topGlycansBarChartOptions,
    xaxis: {
      ...topGlycansBarChartOptions.xaxis,
      categories: categories
    }
  };

  const DataCard = ({ bg, textColor, label, value }) => (
    <Flex direction='row' py='5px' me='5px'>
      <Flex align='center'>
        <Box h='4px' w='4px' bg={bg} borderRadius='10%' me='4px' />
        <Text fontSize='xs' color='secondaryGray.600' fontWeight='700' mb='5px'>
          {label}
        </Text>
      </Flex>
    </Flex>
  );



  const YourCardComponent = ({ percentageData, cardColor, textColor }) => (
    <Card bg={cardColor} flexDirection='column' boxShadow={cardShadow} w='80%' p='15px' px='20px' mt='15px' mx='auto'>
      <Flex flexWrap='wrap' justifyContent='space-between'>
        <DataCard width='48%' bg='#1F78B4' textColor={textColor} label='N4H5F1S2G0' />
        <DataCard width='48%' bg='#A6CEE3' textColor={textColor} label='N4H5F1S1G0' />
        <DataCard width='48%' bg='#E31A1C' textColor={textColor} label='N2H8F0S0G0' />
        <DataCard width='48%' bg='#FB9A99' textColor={textColor} label='N2H9F0S0G0' />
        <DataCard width='48%' bg='#33A02C' textColor={textColor} label='N4H5F0S2G0' />
        <DataCard width='48%' bg='#B2DF8A' textColor={textColor} label='N4H5F0S1G0' />
        <DataCard width='48%' bg='#6A3D9A' textColor={textColor} label='N4H5F2S1G0' />
        <DataCard width='48%' bg='#CAB2D6' textColor={textColor} label='N2H7F0S0G0' />
        <DataCard width='48%' bg='#8F7548' textColor={textColor} label='N2H6F0S0G0' />
        <DataCard width='48%' bg='#FF7F00' textColor={textColor} label='N5H6F1S2G0' />
      </Flex>
    </Card>
  );


  // console.log(chartData);

  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex align='center' w='100%' px='15px' py='10px'>
        <Text
          me='auto'
          color={textColor}
          fontSize='xl'
          fontWeight='700'
          lineHeight='100%'>
          Top Glycans
        </Text>
        <Button
          align='center'
          justifyContent='center'
          bg={bgButton}
          _hover={bgHover}
          _focus={bgFocus}
          _active={bgFocus}
          w='37px'
          h='37px'
          lineHeight='100%'
          // borderRadius='10px'
          {...rest}>
          <Icon as={MdBarChart} color={iconColor} w='24px' h='24px' />
        </Button>
      </Flex>

      <Flex direction='row' py='5px' me='10px'>
        <Box w="60%" h='240px' mt='auto'>
          {isLoading ? (
            <Text>Loading...</Text>
          ) : hasError ? (
            <Text>Error loading chart.</Text>
          ) : (
            <BarChart
              chartData={chartData.series}
              chartOptions={options}
            />
          )}
        </Box>

        <Box w="40%">
          <YourCardComponent
            cardColor={cardColor}
            textColor={textColor}
          />
        </Box>
      </Flex>
      {/* 
      <Box h='240px' mt='auto'>
        <BarChart
          chartData={topGlycansBarChartData}
          chartOptions={topGlycansBarChartOptions}
        />
      </Box> */}
    </Card>
  );
}
